import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { BotRunView } from "./BotRunView";
import { BotRunViewStore } from "../../store/BotRunViewStore";
import { useStore } from "../../../../hooks";

export const BotRunViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/botRun/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new BotRunViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <BotRunView botRunViewStore={store} />
      </PageLayout>
    </div>
  );
});
